import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorComponentComponent } from '@shared/components/error-component/error-component.component';
import { ERRORS, TError } from '@shared/errors';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(
    private snackBar: MatSnackBar
  ) { }

  public errorHandler(error: HttpErrorResponse): void {
    const { error: err } = error;

    if (err?.data?.error) {
      const errorCode = ERRORS.find((error: TError) => error.code === err.data.error);
      if (!errorCode?.message) return;

      this.snackBar.openFromComponent(ErrorComponentComponent, {
        data: errorCode,
        duration: 5000,
        panelClass: ['as-snackbar-warn'],
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      });
    }

    return;
  }
}
